import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { useRef, useCallback } from 'react';
import { mergeRefs } from 'use-callback-ref';
import '../../utils/assertions.es.js';
import { noop } from '../../utils/functions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { useKeyPressWithCallback } from '../../hooks/useKeyPress/useKeyPressWithCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'nanoid/non-secure';
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};

var useModal = function useModal(props) {
  var isOpen = props.isOpen,
      _props$onClose = props.onClose,
      onClose = _props$onClose === void 0 ? noop : _props$onClose,
      _props$isDismissible = props.isDismissible,
      isDismissible = _props$isDismissible === void 0 ? true : _props$isDismissible,
      closeOnOverlayClick = props.closeOnOverlayClick;
  var modalRef = useRef(null);
  var modalWrapperRef = useRef(null);
  var mouseDownTarget = useRef(null);
  var handleMouseDown = useCallback(function (event) {
    return mouseDownTarget.current = event.target;
  }, []);
  var handleWrapperClick = useCallback(function (event) {
    event.stopPropagation();

    if (mouseDownTarget.current !== event.target || modalWrapperRef.current !== event.target || !closeOnOverlayClick || !isDismissible) {
      return;
    }

    onClose == null ? void 0 : onClose();
  }, [closeOnOverlayClick, isDismissible, onClose]);
  var getModalProps = useCallback(function (props2, ref) {
    if (props2 === void 0) {
      props2 = {};
    }

    if (ref === void 0) {
      ref = null;
    }

    return __spreadProps(__spreadValues({}, props2), {
      ref: mergeRefs([ref, modalRef]),
      role: "dialog",
      tabIndex: -1,
      "aria-modal": true
    });
  }, []);
  var getModalWrapperProps = useCallback(function () {
    return {
      ref: modalWrapperRef,
      onClick: handleWrapperClick,
      onMouseDown: handleMouseDown
    };
  }, [handleWrapperClick, handleMouseDown]);
  useKeyPressWithCallback("Escape", function () {
    return isDismissible && (onClose == null ? void 0 : onClose());
  });
  return {
    isOpen: isOpen,
    onClose: onClose,
    isDismissible: isDismissible,
    getModalProps: getModalProps,
    getModalWrapperProps: getModalWrapperProps
  };
};

export { useModal };